import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { prefersReducedMotion } from "../utils/motion"

gsap.registerPlugin(ScrollTrigger)

export default function initParallax() {
	if (prefersReducedMotion()) {
		gsap.set('[data-parallax-image]', { clearProps: 'transform' })
		return
	}

	const parallaxContainers = document.querySelectorAll('[data-parallax-container]')

	parallaxContainers.forEach((container) => {
		const parallaxImage = container.querySelector('[data-parallax-image]')

		if (!parallaxImage) {
			return
		}

		parallaxImage.parallaxTween?.kill()

		parallaxImage.parallaxTween = gsap.to(parallaxImage, {
			yPercent: 20,
			ease: 'none',
			scrollTrigger: {
				trigger: container,
				start: 'top bottom',
				end: 'bottom top',
				scrub: true,
			}
		})
	})
	
}
